module.exports = __webpack_public_path__ + "static/vatbot-profile-524e9f849fa7d5d71dcaa59f0f36fbba.png";